import React from "react";
import Container from "../../components/misc/Container";
import { Link } from "react-router-dom";
import LayoutHomepage from "../../layout/LayoutHomepage";

import BawahPutih from "../../assets/images/resep/tumis-tahu/BAWANGPUTIH.jpeg";
import BawangMerah from "../../assets/images/resep/tumis-tahu/BAWANGMERAH.jpeg";
import Jahe from "../../assets/images/resep/soto/JAHE.png";
import JamurTiram from "../../assets/images/resep/tumis-tahu/JamurTiram.jpeg";
import Lombok from "../../assets/images/resep/tumis-tahu/CABAIRAWIT.jpeg";
import DaginAyam from "../../assets/images/resep/daging-goreng.svg";
import DagingSapi from "../../assets/images/daging/sapi/1.DagingSapi.jpeg";


// Import Icon
import { ReactComponent as ClockIcon } from "../../assets/icons/icon-ios-timer.svg";
import { ReactComponent as ForkIcon } from "../../assets/icons/icon-fork-eat.svg";
import DynamicScrollToTop from "../../components/misc/DynamicScrollToTop";
import classnames from "classnames";

const DagingGoreng = () => {

    let recipe = {
        recipeTitle : "Daging Goreng Krispi",
        recipeHour : "1",
        recipePortion : "4",
        status : "Sulit",
        imgSrc : DaginAyam
    }

    let igredients = [
      {
        imgSrc : DagingSapi,
        imgAlt : "",
        title : "Daging Sapi",
        weight : "250gr",
        price : "Rp8000",
        discountPrice : "",
    },
        {
            imgSrc : Lombok,
            imgAlt : "",
            title : "Cabai Rawit",
            weight : "250gr",
            price : "Rp8000",
            discountPrice : "",
        },
        {
            imgSrc : BawahPutih,
            imgAlt : "",
            title : "Bawang Putih",
            weight : "250gr",
            price : "Rp7500",
            discountPrice : "",
        },
        {
            imgSrc : Jahe,
            imgAlt : "",
            title : "Jahe keraton",
            weight : "250gr",
            price : "Rp6500",
            discountPrice : "",
        },
        {
            imgSrc : JamurTiram,
            imgAlt : "",
            title : "Jamur Tiram",
            weight : "250gr",
            price : "Rp7000",
            discountPrice : "",
        },
        {
            imgSrc : BawangMerah,
            imgAlt : "",
            title : "Bawang Merah",
            weight : "250gr",
            price : "Rp3500",
            discountPrice : "",
        },
    ]

  return (
    <>
      <DynamicScrollToTop />
      <LayoutHomepage>
        <div className="flex flex-col w-full mt-32">
          <Container>
            <div className="flex flex-col w-full mr-2">
              <div className="flex w-full mb-2 mt-8">
                <p className="flex items-center text-font-gray opacity-50">
                  <Link to="/homepage">Beranda </Link>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3 h-3 opacity-100 mx-2"
                    viewBox="0 0 11.384 20.025"
                  >
                    <g
                      id="Group_4034"
                      data-name="Group 4034"
                      transform="translate(1.414 1.414)"
                    >
                      <line
                        id="Line_452"
                        data-name="Line 452"
                        x2="12.099"
                        transform="translate(8.555 8.642) rotate(135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                      <line
                        id="Line_453"
                        data-name="Line 453"
                        x2="12.099"
                        transform="translate(8.555 8.555) rotate(-135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                    </g>
                  </svg>
                  <Link to="/recipe">Resep</Link>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3 h-3 opacity-100 mx-2"
                    viewBox="0 0 11.384 20.025"
                  >
                    <g
                      id="Group_4034"
                      data-name="Group 4034"
                      transform="translate(1.414 1.414)"
                    >
                      <line
                        id="Line_452"
                        data-name="Line 452"
                        x2="12.099"
                        transform="translate(8.555 8.642) rotate(135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                      <line
                        id="Line_453"
                        data-name="Line 453"
                        x2="12.099"
                        transform="translate(8.555 8.555) rotate(-135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                    </g>
                  </svg>
                </p>
                <p className="flex items-center text-font-gray">
                  {recipe.recipeTitle}
                </p>
              </div>
              <div className="flex">
                <div className="flex">
                  <div className="border rounded-md bg-white mb-8 mr-8 mt-8">
                    <img alt={recipe.imgAlt} className="m-4 rounded-md" src={recipe.imgSrc} />
                  </div>
                </div>
                <div className="flex-grow rounded overflow-hidden shadow-lg flex flex-col justify-center items-center pl-12">
                  <div className="flex justify-start flex-col w-full">
                    <h1 className="text-3xl font-bold text-left">
                      {recipe.recipeTitle}
                    </h1>
                    <div className="bg-white rounded-lg flex justify-center align-center mt-4 w-9/12 shadow-sm">
                      <div className="px-6 py-3 flex items-center w-full">
                        <div className="flex items-center">
                          <ClockIcon className="w-4 h-4 mr-2" />
                          <p className="font-semibold">{recipe.recipeHour} Jam</p>
                        </div>

                        <div className="flex items-center mx-auto">
                          <ForkIcon className="w-4 h-4 mr-2" />
                          <p className="font-semibold">{recipe.recipePortion} Porsi</p>
                        </div>
                        <span className={classnames("font-semibold",{ "text-green-100 bg-greenlight-100 border border-green-100 px-4 py-1" : recipe.status === "Mudah",
                        "text-basic-orange bg-orange-100 border border-basic-orange px-4 py-1" : recipe.status === "Sedang",
                        "text-red-600 bg-red-100 border border-red-600 px-4 py-1" : recipe.status === "Sulit",
                    }, "rounded-md")}>
                        {recipe.status}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h1 className="text-2xl semi-bold mt-4 mb-2">Bahan Baku</h1>
              <div className="flex">
                <div className="flex flex-wrap w-full -mx-2">
                  {/* Items  */}

                  {igredients.map((item, index) => (
                  <div className="flex flex-col bg-white rounded pt-2 mx-2 my-2">
                    <div className="flex flex-col px-3 pb-2">
                      <Link to="/category-detail">
                        <img src={item.imgSrc} alt="Brokoli" className="h-32" />
                      </Link>
                      <div className="flex flex-col mb-2">
                        <p className="text-font-gray ">{item.title}</p>
                        <p className="text-font-gray-text text-xs">{item.weight}</p>
                      </div>
                      <p className="text-gray-400 text-sm line-through">
                        <br/>
                      </p>
                      <p className="text-gray-600 ">{item.price}</p>
                    </div>
                    <Link to="/category-detail">
                      <div className="flex w-full py-2 px-3 bg-gray-100 text-basic-orange text-lg items-center justify-center rounded-b">
                        Beli
                      </div>
                    </Link>
                  </div>
                  ))}

                  {/* End Items  */}
                </div>
              </div>
              <h1 className="text-2xl font-semibold mb-2 mt-4">Bahan Bahan</h1>
              <div className="flex w-full">
                <div className="flex-wrap mr-10 mb-10 ">
                  <div className="bg-white p-10">
                    <div className="flex p-1">
                      <h3 className="font-bold">Bahan</h3>
                    </div>
                    <div className="flex mt-8">
                      <div className="flex-wrap mr-4 font-bold">700g</div>
                      <div className="flex-wrap">Daging sapi, potong tipis-tipis</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">200g</div>
                      <div className="flex-wrap">Tepung panir</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">2 btr</div>
                      <div className="flex-wrap">Butir telur ayam, kocok</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">1 sdt</div>
                      <div className="flex-wrap">Garam</div>
                    </div>
                  </div>
                  <div className="bg-white p-10 ">
                    <div className="flex p-1">
                      <h3 className="font-bold">Bumbu halus</h3>
                    </div>
                    <div className="flex mt-8">
                      <div className="flex-wrap mr-4 font-bold">12pcs</div>
                      <div className="flex-wrap">Bawang merah</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">2cm</div>
                      <div className="flex-wrap">Jahe</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">4 pcs</div>
                      <div className="flex-wrap">Kemiri</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">8cm</div>
                      <div className="flex-wrap">Kunyit bakar</div>
                    </div>
                  </div>
                  <div className="bg-white p-10">
                    <div className="flex p-1">
                      <h3 className="font-bold">Bumbu saos</h3>
                    </div>
                    <div className="flex mt-8">
                      <div className="flex-wrap mr-4 font-bold">3 btr</div>
                      <div className="flex-wrap">
                      Bawang putih, cincang halus
                      </div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">1 bh</div>
                      <div className="flex-wrap">Tomat, potong dadu kecil</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">2 sdm</div>
                      <div className="flex-wrap">Kecap manis</div>
                    </div>
                    <div className="flex mt-4">
                      <div className="flex-wrap mr-4 font-bold">100ml</div>
                      <div className="flex-wrap">Air</div>
                    </div>
                  </div>
                </div>
                <div className="flex-wrap w-8/12 ">
                  <div className="flex flex-col bg-white rounded">
                    <div className="p-4">
                      <h1 className="font-bold text-xl text-basic-orange text-center">
                        Cara membuat
                      </h1>
                      <ul className="mt-4">
                        <li className="m-8">
                          1. Memarkan daging, lalu bumbui dengan bawang putih dan garam. Diamkan selama 30 menit.
                        </li>
                        <li className="m-8">
                          2. Baluri daging dengan tepung terigu, celupkan ke telur, lalu lumuri dengan tepung panir. Ulangi proses ini dua kali.

                        </li>
                        <li className="m-8">
                          3. Panaskan margarin, tumis bawang putih dan bombay hingga harum.
                        </li>
                        <li className="m-8">
                          4. Masukkan Kecap Manis , air, gula, merica, air perasan jeruk nipis, dan irisan tomat. Aduk rata, masak hingga mengental..
                        </li>
                        <li className="m-8">
                          5. Tata daging di piring, tuangkan saus ke atasnya. Sajikan selagi hangat..
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </LayoutHomepage>
    </>
  );
};

export default DagingGoreng;
